import { PictoChartWebElementBase } from './PictoChartWebElementBase';

/**
 * The component WebElement for [oj-c-picto-chart](../../../oj-c/docs/oj.PictoChart.html).
 * Do not instantiate this class directly, instead, use
 * [findPictoChart](../modules.html#findPictoChart).
 */
export class PictoChartWebElement extends PictoChartWebElementBase {
  // Put overrides here
}
